<template>
    <div>
        <b-row v-if="permissions.includes('sales-target-inquiry')">
            <!-- card collapsible  -->
            <b-col md="12">
                <b-card-actions
                title="Filter"
                :collapsed="true"
                action-collapse
                >
                    <b-row>
                        <b-col md="3">
                            <b-form-group
                            label="Priority"
                            label-for="priority"
                            >
                                <b-form-select
                                id="priority"
                                v-model="filter.selectedPriority"
                                :options="filter.optionsPriority"
                                />
                                <!-- Selected: <strong>{{ filter.selectedPriority }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Start Date"
                            label-for="start_date"
                            >
                                <flat-pickr
                                id="start_date"
                                v-model="filter.start_date"
                                class="form-control"
                                :config="{ dateFormat: 'd-m-Y'}"
                                placeholder="Start Date"
                                />
                                <!-- <p>Value: '{{ filter.start_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="End Date"
                            label-for="end_date"
                            >
                                <flat-pickr
                                id="end_date"
                                v-model="filter.end_date"
                                class="form-control"
                                :config="{ dateFormat: 'd-m-Y'}"
                                placeholder="End Date"
                                />
                                <!-- <p>Value: '{{ filter.end_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Status"
                            label-for="status"
                            >
                                <b-form-select
                                id="status"
                                v-model="filter.selectedStatus"
                                :options="filter.optionsStatus"
                                />
                                <!-- Selected: <strong>{{ filter.selectedStatus }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mt-1"
                            @click="getInquiry(1, filter.selectedPriority, filter.start_date, filter.end_date, filter.selectedStatus)"
                            >
                            Search
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-actions>
            </b-col>
        </b-row>
        <b-row v-if="permissions.includes('sales-target-create')">
            <b-col class="text-right mb-1">
                <router-link to="/sales/target/add">
                    <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="primary"
                    pill
                    class="px-3"
                    >
                    Add Target
                    </b-button>
                </router-link>
            </b-col>
        </b-row>
        <b-card v-if="permissions.includes('sales-target-inquiry')">
            <!-- search input -->
            <!-- <b-row>
                <b-col class="custom-search d-flex justify-content-end">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <b-form-input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block"
                            />
                        </div>
                    </b-form-group>
                </b-col>
            </b-row> -->

            <!-- table -->
            <vue-good-table
            :columns="columns"
            :rows="rows"
            :rtl="direction"
            :search-options="{
                enabled: true,
                externalQuery: searchTerm 
            }"
            :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
            :pagination-options="{
                enabled: true,
                perPage:pageLength
            }"
            >
                <template
                    slot="table-row"
                    slot-scope="props"
                >

                    <!-- Column: Name -->
                    <span
                    v-if="props.column.field === 'title'"
                    class="text-nowrap"
                    >
                        <span class="text-nowrap">{{ props.row.title }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                        <b-badge :variant="statusVariant(props.row.status)">
                            <span v-if="props.row.status === 0">{{ props.row.status_name }}</span>
                            <span v-else-if="props.row.status === 1">{{ props.row.status_name }}</span>
                        </b-badge>
                    </span>

                    <!-- Column: Date -->
                    <span
                    v-else-if="props.column.field === 'created_at'"
                    class="text-nowrap"
                    >
                        <span class="text-nowrap">{{ moment(props.row.created_at) }}</span>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                        <span>
                            <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            >
                                <template v-slot:button-content>
                                    <feather-icon
                                    icon="MoreVerticalIcon"
                                    size="16"
                                    class="text-body align-middle mr-25"
                                    />
                                </template>
                                <b-dropdown-item v-bind:to="{path: '/sales/target/' +props.row.id}" v-if="permissions.includes('sales-target-detail')">
                                    <feather-icon
                                    icon="Edit2Icon"
                                    class="mr-50"
                                    />
                                    <span>Detail</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="deleteTarget(props.row.id)" v-if="permissions.includes('sales-target-delete')">
                                    <feather-icon
                                    icon="TrashIcon"
                                    class="mr-50"
                                    />
                                    <span>Delete</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>

                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap ">
                            Showing {{ meta.from }} to {{ meta.to }}
                            </span>
                            <span class="text-nowrap">&nbsp;of {{ meta.total }} entries </span>
                        </div>
                        <div>
                            <b-pagination
                            :value="1"
                            :total-rows="meta.total"
                            :per-page="meta.per_page"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mt-1 mb-0"
                            @input="(value)=>getInquiry(value, filter.selectedPriority, filter.start_date, filter.end_date, filter.selectedStatus)"
                            >
                            <template #prev-text>
                                <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                                />
                            </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-card>
    </div>
</template>

<script>
import {
    BForm, BFormFile, BModal, BButton, BRow, BCol, BCard, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        flatPickr,
        BCardActions,
        VueGoodTable,
        ToastificationContent,
        ValidationProvider,
        ValidationObserver,
        BForm,
        BFormFile,
        BModal,
        BButton,
        BRow,
        BCol,
        BCard, 
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [
                {
                    label: 'Priority',
                    field: 'priority_name',
                },
                {
                    label: 'Title',
                    field: 'title',
                },
                {
                    label: 'Description',
                    field: 'description',
                },
                {
                    label: 'Date',
                    field: 'created_at',
                },
                {
                    label: 'Status',
                    field: 'status',
                },
                {
                    label: 'Action',
                    field: 'action',
                    width: '100px'
                },
            ],
            filter: {
                selectedPriority: '',
                optionsPriority: [
                    {value: '', text: 'All'},
                    {value: 1, text: 'Low'},
                    {value: 2, text: 'Normal'},
                    {value: 3, text: 'High'},
                    {value: 4, text: 'Urgent'}
                ],
                start_date: '',
                end_date: '',
                selectedStatus: '',
                optionsStatus: [
                    {value: '', text: 'All'},
                    {value: '0', text: 'Not Finished'},
                    {value: 1, text: 'Finished'}
                ],
            },
            meta: {
                current_page: 1,
                last_page: 0,
                from: 0,
                to: 0,
                per_page: 10,
                total: 0,
            },
            permissions: [],
            search: '',
            rows: [],
            searchTerm: '',
            errors: '',
            errMessage: '',
            file: null
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                0 : 'light-warning',
                1 : 'light-success'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        this.getAllPermissions()
        this.getInquiry(1, '', '', '', '')
    },
    methods: {
        moment(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getInquiry($page, $priority, $start_date, $end_date, $status) {
            this.$http.get('sales/targets?page=' + $page + ($priority ? "&priority="+this.filter.selectedPriority : '') + ($start_date ? "&start_date="+this.filter.start_date : '') + ($end_date ? "&end_date="+this.filter.end_date : '') + ($status ? "&status="+this.filter.selectedStatus : ''))
            .then(res => { 
                this.rows = res.data.data
                // console.log(res.data.data)
                var meta = res.data.meta
                if (meta.from != null) {
                    this.meta.from = meta.from
                }
                if (meta.to != null) {
                    this.meta.to = meta.to
                }
                this.meta.current_page = meta.current_page
                this.meta.last_page = meta.last_page
                this.meta.per_page = meta.per_page
                this.meta.total = meta.total
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            })
        },
        deleteTarget($id) {
            this.$http
            .post("sales/target/"+$id+"/delete")
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Target has been Deleted',
                        variant: 'danger',
                    },
                })
                location.href = "/sales/target"
                // console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                console.log(errors.response)
            })
        },
    },
}
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>